var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("PageTemplate", {
    scopedSlots: _vm._u([
      {
        key: "page-content",
        fn: function () {
          return [
            _c(
              "div",
              { attrs: { id: "paypoint-terms-and-conditions-page" } },
              [
                _c(
                  "b-container",
                  { attrs: { fluid: "", id: "page-container" } },
                  [
                    _c(
                      "div",
                      { attrs: { id: "content-container-with-border" } },
                      [
                        _c("h1", [_vm._v("Terms and Conditions")]),
                        _vm._v(" "),
                        _c("h2", [_vm._v("Legal")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            '\n            References to "you" or "your" are references to any person\n            accessing this website ("site").\n          '
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            '\n            References to "we", "us" or "our" are references to PayPoint\n            Network Limited.\n          '
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            '\n            References to "PayPoint Group" are references to us, our parent\n            company and any companies we or our parent company totally or\n            partly own at any time.\n          '
                          ),
                        ]),
                        _vm._v(" "),
                        _c("h2", [_vm._v("Purpose")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            This page (together with the documents referred to on it) tells\n            you the terms of use on which you may make use of the PayPoint\n            website www.My.PayPoint.com.\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            Please read these terms of use carefully before you start to use\n            the website. By using the website, you indicate that you accept\n            these terms of use and that you agree to abide by them. If you do\n            not agree to these terms of use, please refrain from using the\n            My.PayPoint website.\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("h2", [_vm._v("Operation")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            '\n            www.My.PayPoint.com is a website operated by PayPoint Network\n            Limited ("PayPoint"). PayPoint Network Limited is registered in\n            England under company number 02973115 and has its registered\n            office at 1 The Boulevard, Shire Park, Welwyn Garden City,\n            Hertfordshire AL7 1EL. PayPoint is part of the PayPoint PLC group\n            of companies.\n          '
                          ),
                        ]),
                        _vm._v(" "),
                        _c("h2", [_vm._v("My.PayPoint.Com")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            My.PayPoint.com provides you with access to information about the\n            services we provide to you and the services you provide to us. It\n            enables you to access reports on your store's performance, set up\n            new products & promotions, and configure your till configuration\n            to manage your operation efficiently.\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("h2", [_vm._v("Access")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            The content of this site includes financial information about your\n            business. You are responsible for ensuring you only grant access\n            to those you wish to see or review this information. You can limit\n            the access rights of individuals by changing the settings by\n            visiting User Management in My.PayPoint.com.\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            We reserve the right to modify, suspend or discontinue,\n            temporarily or permanently, the site or any part of it, with or\n            without notice, at any time. You agree that we shall not be liable\n            to you or to any third party for any such modification, suspension\n            or discontinuance of the site.\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("h2", [_vm._v("Registration, Log-in and Security")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            If you wish to use the My.PayPoint.com website you must first\n            register as a user and be eligible to register (please contact\n            PayPoint using the details below for information on eligibility).\n            You must provide accurate and complete registration information\n            and will need to set up both a Username and a Password in order in\n            order to register.\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "There are two ways to log-in to My.PayPoint.com:"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("h3", [_vm._v("Log-in Method 1.")]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "\n              Using your Site Number (the number assigned to your site\n              location by PayPoint and available on your PayPoint\n              documentation).\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "\n              A “Username”- when logging in as a Site this will be created for\n              you at install, and you can create further users with distinct\n              Usernames via the User Management option in My.PayPoint.com.\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              '\n              A "Password"- this is a confidential word or number or\n              combination used as a code to confirm your identity when\n              accessing My.PayPoint. This must be between 8 and 15 characters\n              (when logging in using a Site Number). We strongly recommend a\n              secure password including a mix of letters, numbers and special\n              characters.\n            '
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            If you log-in using Log-in Method 1, you will be able to see sales\n            and operational information for the specific Site assigned the\n            Site Number you used to log-in with, as well as your usual access\n            to statements.\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("h3", [_vm._v("Log-in Method 2.")]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "\n              Email Address- this is the email address nominated by you at the\n              time you register to use My.PayPoint.com, when logging in an as\n              an Agent.\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              '\n              A "Password"- this is a confidential word or number or\n              combination used as a code to confirm your identity when\n              accessing My.PayPoint. This must be between 8 and 15 characters\n              and (when logging in using an email address) it must also\n              include three from: an uppercase or lowercase letter, number and\n              special character.\n            '
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            If you log-in using Log-in Method 2, you will only have access to\n            your statements and data, you will not be able to retrieve sales\n            and operational information in relation to a specific Site.\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            PayPoint will use reasonable endeavours to ensure that access to\n            My.PayPoint.com is possible at all times, however no warranty or\n            guarantee is provided in this respect and PayPoint shall not be\n            liable in any way if the website is unavailable.\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            PayPoint may at any time, and without notice, withdraw\n            My.PayPoint.com in part or in its entirety, or restrict or prevent\n            you from accessing the website if PayPoint has reasonable grounds\n            for doing so.\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            PayPoint endeavours to maintain a high level of internet security.\n            To maintain such security you must:\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "\n              ensure that both your username and password are kept secure at\n              all times;\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "\n              when choosing a password, ensure that it is one that is not\n              likely to be anticipated by anyone attempting to access\n              My.PayPoint.com pretending to be you. We strongly recommend a\n              secure password including a mix of letters, numbers and special\n              characters;\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "\n              not disclose your username or password to anyone. PayPoint\n              support colleagues, if needed, will able to offer remote support\n              without this information;\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "\n              not record your password in any form that identifies it as being\n              a password to access My.PayPoint.com;\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "\n              contact PayPoint on the contact details below immediately upon\n              discovering or suspecting that your password is being used by or\n              is known by any third party;\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "\n              not allow any other person to access your My.PayPoint.com\n              account;\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "\n              ensure that nobody can see, copy or access information, or\n              obtain your username and/or password when you are using your\n              My.PayPoint.com account;\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "\n              not, whilst accessing My.PayPoint.com, leave your computer or\n              any similar device used for accessing the website unattended;\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "\n              prior to accessing the service from any computer connected to a\n              local area network or LAN, take steps to ensure that no other\n              party will be able to see, copy or access information and/or\n              obtain your username and/or password;\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "\n              change your password immediately if PayPoint requests that you\n              do so; and\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "\n              take all reasonable steps to ensure that the computer or any\n              similar device that you are accessing My.PayPoint.com from is\n              free from computer viruses. You also agree to take reasonable\n              measures to ensure that the computer or other device you are\n              using is itself adequately protected against the receipt of\n              computer viruses.\n            "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("h2", [_vm._v("Reporting")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            You can access reports detailing your store's sales performance,\n            with margin and profit calculations. You can also access Stock\n            Reports and view reports showing till events, PayPoint Sales, and\n            promotion performance. All reports are subject to the data\n            (including but not limited to, stock costs and prices) that you\n            have provided in the My.PayPoint.com site and till.\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _c("strong", [
                            _vm._v(
                              "\n              It is important to check your reports regularly, especially when\n              using these for external reporting or reconciliation purposes.\n              PayPoint assumes no any liability for the accuracy of these\n              reports.\n            "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("h2", [_vm._v("Intellectual Property")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            '\n            You are responsible for obeying all applicable laws relating to\n            the intellectual property rights subsisting in this website. The\n            information and graphics contained in this website are protected\n            by copyright under national laws and international treaties. The\n            website may be copied for the purpose of viewing, but may not be\n            permanently stored or copied for further distribution. "PayPoint"\n            is a trademark of PayPoint Network Limited a subsidiary of\n            PayPoint PLC.\n          '
                          ),
                        ]),
                        _vm._v(" "),
                        _c("h2", [_vm._v("Privacy and Cookies")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            For information on how PayPoint uses personal data and cookies,\n            please "
                          ),
                          _c("a", { attrs: { href: "/PrivacyAndCookies" } }, [
                            _vm._v("click here"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("h2", [_vm._v("Financial Promotions")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            The material contained in this website is a guide for general\n            information purposes only. This website does not provide or offer\n            financial or other advice and its contents should not be relied\n            upon as such.\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            This website does not give any advice or make any recommendation\n            (and should not be construed as so doing) and should not be relied\n            upon. Any and all liability which might arise from your use or\n            reliance on the information or links contained on the website is\n            excluded. Actual results or developments may be materially\n            different from any forecast, opinion or expectation expressed on\n            this website and the past performance of the price of securities\n            must not be relied upon as a guide to their future performance.\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            Nothing on this website constitutes an invitation or offer to\n            enter into any sort of commercial arrangement for the provision of\n            goods and service by PayPoint. These terms and conditions of use\n            are not PayPoint's terms of business which would be made available\n            to a prospective business partner at the appropriate time.\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            Nothing on this website constitutes an invitation or offer to\n            invest or deal in the securities of PayPoint.\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("h2", [_vm._v("Disclaimer")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            PayPoint seeks to ensure that the information on this website\n            (other than information accessed by hypertext links) is accurate.\n            However, no representation or warranty is made and no liability is\n            accepted as to the accuracy, completeness or any other aspect of\n            the information or links contained on the website. Any and all\n            liability which might arise from your use or reliance on the\n            information or links contained on the website is excluded unless\n            such liability results from fraudulent misrepresentation or is for\n            death or personal injury caused by negligence.\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            You are reminded that the internet is an inherently unstable\n            medium and the risks of interruption, interference and disruption\n            mean that the information or links contained on this website may\n            in fact be outside the control of PayPoint. In addition, errors,\n            omissions, interruptions and delays of service may occur at any\n            time, and PayPoint accepts no obligation or responsibility in\n            respect of such events.\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("h2", [_vm._v("Electronic Links")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            Due to the nature of the My.PayPoint site, electronic links to\n            this website are prohibited without the consent of PayPoint. You\n            may not frame this website without the consent of PayPoint.\n            Certain links on this website may lead to third party websites\n            and/or assets located on servers maintained by third parties over\n            whom PayPoint has no control. PayPoint makes no representation as\n            to the accuracy or any other aspect of, and accepts no liability\n            of any kind for, the information contained on such websites or in\n            such assets or on such servers.\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("h2", [_vm._v("Legal Compliance")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            It is the responsibility of any person accessing this website in\n            any jurisdiction to satisfy themselves as to the full observance\n            of the laws and regulatory requirements of the relevant\n            jurisdiction, including the obtaining of governmental or other\n            consents which may be required or observing any other formality or\n            restriction that needs to be observed in such jurisdiction. Any\n            failure to comply with any formality or failure to observe any\n            restriction may constitute a violation of the securities laws of\n            any such jurisdiction.\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("h2", [_vm._v("Updates and Amendments")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            PayPoint may revise these terms of use at any time by amending\n            this page. You are expected to check this page from time to time\n            to take notice of any changes PayPoint makes, as they are binding\n            on you. Some of the provisions contained in these terms of use may\n            also be superseded by provisions or notices published elsewhere on\n            the website.\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("h2", [_vm._v("Legal Information")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            PayPoint Network Limited is a limited company (Company\n            Registration Number 02973115) whose registered office is at 1 The\n            Boulevard, Shire Park, Welwyn Garden City, Hertfordshire, England,\n            AL7 1EL.\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            For additional contact information please email:\n            "
                          ),
                          _c(
                            "a",
                            {
                              attrs: { href: "mailto:contactus@paypoint.com" },
                            },
                            [_vm._v("contactus@paypoint.com")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("h2", [_vm._v("Terms of Business")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            For the Terms of Business applicable to each of the PayPoint\n            Services please see the information provided on the appropriate\n            Service website.\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("h2", [_vm._v("Contact")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            If you have any concerns about material which appears on\n            PayPoint's website, please email:\n            "
                          ),
                          _c(
                            "a",
                            {
                              attrs: { href: "mailto:contactus@paypoint.com" },
                            },
                            [_vm._v("contactus@paypoint.com")]
                          ),
                          _vm._v(
                            "\n            or call us on 0330 400 0000\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("h2", [_vm._v("Governing law")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            English law governs these terms and conditions and you agree that\n            the English Courts shall have exclusive jurisdiction to determine\n            any matter or dispute in connection with or arising out of this\n            site and these terms and conditions.\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            This site is designed for use in the UK and is not directed to,\n            nor intended for distribution or use by, any person or entity in\n            any jurisdiction or country where the publication or availability\n            of this site or such distribution or use would be contrary to\n            local law or regulation. If you choose to access information on\n            this site, it is your responsibility to comply with the applicable\n            local, national or international laws and any use of this site\n            outside the UK is entirely at your own risk. For guidance relating\n            to your specific situation, please contact your legal adviser.\n          "
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }